import { A11yModule } from '@angular/cdk/a11y';
import { Component, OnInit, inject } from '@angular/core';
import { DynamicFormComponent } from '@ebeihilfe/forms';
import { KurzantragBase } from '@ebeihilfe/einreichung-old';
import { LegacyAntragsMetadata } from '@eBeihilfe/einreichung-shared/model';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { Stammdaten } from '@ebeihilfe/core';
import { TranslateModule } from '@ngx-translate/core';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
    selector: 'portal-antrag-modal',
    templateUrl: './antrag-modal.component.html',
    styleUrls: ['./antrag-modal.component.scss'],
    imports: [
        MatDialogModule,
        TranslateModule,
        A11yModule,
        MatDividerModule,
        ReactiveFormsModule,
        RouterLink,
        MatButtonModule,
        DynamicFormComponent,
    ]
})
export class AntragModalComponent extends KurzantragBase implements OnInit {
  private readonly stammdaten: Stammdaten = inject(MAT_DIALOG_DATA);
  private readonly dialogRef: MatDialogRef<AntragModalComponent> = inject(MatDialogRef<AntragModalComponent>);

  public ngOnInit(): void {
    this.userData = this.stammdaten;
    super.ngOnInit();
  }

  public updateModel(model: Record<string, unknown>): void {
    this.model = model;
  }

  protected closeUp(antragsMetadata: LegacyAntragsMetadata[]): void {
    this.dialogRef.close({
      type: this.form.value['antragsArt'], // 💩 we shouldn't need hard coded stuff
      data: antragsMetadata,
    });
  }
}
